import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http'
import {
    ApplicationConfig,
    ErrorHandler,
    inject,
    provideAppInitializer,
    provideBrowserGlobalErrorListeners,
    provideZonelessChangeDetection,
} from '@angular/core'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideRouter, withInMemoryScrolling } from '@angular/router'
import {
    MSAL_GUARD_CONFIG,
    MSAL_INSTANCE,
    MSAL_INTERCEPTOR_CONFIG,
    MsalBroadcastService,
    MsalGuard,
    MsalService,
} from '@azure/msal-angular'
import { MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from '@ui-core/msal/msal'
import { ErrorHandlerService } from '@ui-core/services/error-handler.service'
import { InitService } from '@ui-core/services/init.service'
import { providePrimeNG } from 'primeng/config'
import { routes } from './app.routes'
import CustomPreset from './customPreset'
import { AuthInterceptor } from '@ui-core/interceptors/auth.interceptor'

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimationsAsync(),
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideRouter(
            routes,
            withInMemoryScrolling({
                scrollPositionRestoration: 'top',
                anchorScrolling: 'enabled',
            })
        ),
        providePrimeNG({
            theme: {
                preset: CustomPreset,
                options: {
                    darkModeSelector: false,
                },
            },
        }),
        provideHttpClient(withFetch(), withInterceptorsFromDi(), withInterceptors([AuthInterceptor])),
        provideAppInitializer(() => {
            const initService = inject(InitService)
            initService.initApiUrl().initMenu()
        }),
        {
            provide: ErrorHandler,
            useClass: ErrorHandlerService,
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory,
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory,
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
    ],
}
